import React from 'react';
import './VisitorMap.css';

const VisitorMap = () => {
  return (
    <div className="visitor-map">
      <a href="https://clustrmaps.com/site/1c1sl" title="Visit tracker">
        <img
          src="//cdn.clustrmaps.com/map_v2.png?cl=ffffff&w=500&t=tt&d=VeqnpzLlKW-Ot5DN3F-Amu4pFn2pWHIYPqjUluz5gTI"
          alt="Visitor Map"
        />
      </a>
    </div>
  );
};

export default VisitorMap;